import React, {useState, useEffect} from 'react';
import styles from './Desktop.module.scss';
import './styles.css';
import {withRouter} from 'react-router-dom';
import {AgGridReact} from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-balham.css';
import moment from 'moment';
import PermitsHeader from '../../../../../components/PermitsHeader';
import SannaLogo from '../../../../../components/SannaLogo';
import dimensions from '../../../../../util/dimensions-util';
import {
  DEPT_REPORT_TABS,
  handleDeptReportTabClick,
} from '../../../shared/deptReportTabs';

const {vw: widthConstant, vh: heightConstant} = dimensions;

const Desktop = props => {
  const {onClick, onChange, totalCount, pageSize} = props;

  const [gridApi, setGridApi] = useState(null);

  const onGridReady = params => {
    setGridApi(params.api);
    onChange('gridAPI', params.api);
  };

  const updateTable = () => {
    onChange('updateTable', null);
  };

  useEffect(() => {
    if (gridApi && totalCount > 10) {
      gridApi.setDomLayout('normal');
    } else if (gridApi) {
      gridApi.setDomLayout('autoHeight');
    }
  }, [gridApi, totalCount]);

  useEffect(() => {
    if (gridApi) {
      updateTable();
    }
  }, [gridApi]);

  const defaultCellStyle = {
    display: 'flex',
    alignItems: 'center',
    lineHeight: 1.5,
    whiteSpace: 'normal',
    wordBreak: 'break-word',
  };

  const formatTimestamp = value => {
    if (value === null || value === undefined || value === '') {
      return '-';
    }
    const parsed = moment(Number(value));
    return parsed.isValid() ? parsed.format('D MMM YYYY HH:mm') : '-';
  };

  const formatFileName = value =>
    value !== null && value !== undefined && value !== '' ? value : '-';

  const canDownload = row => {
    if (row?.status !== 'COMPLETED' || !row?.downloadUrl) {
      return false;
    }
    if (row?.expiresAt && moment().isAfter(moment(Number(row.expiresAt)))) {
      return false;
    }
    return true;
  };

  const columnDefs = [
    {
      headerName: 'File Name',
      field: 'fileName',
      headerClass: styles.rowHeader,
      flex: 1,
      minWidth: 320 * widthConstant,
      resizable: true,
      wrapText: true,
      cellStyle: defaultCellStyle,
      valueFormatter: params => formatFileName(params.value),
    },
    {
      headerName: 'Created Date',
      field: 'createdDate',
      headerClass: styles.rowHeader,
      width: 200 * widthConstant,
      resizable: true,
      wrapText: true,
      cellStyle: defaultCellStyle,

      valueFormatter: params => formatTimestamp(params.value),
    },
    {
      headerName: 'Period',
      field: 'period',
      headerClass: styles.rowHeader,
      width: 330 * widthConstant,
      resizable: true,
      wrapText: true,
      cellStyle: defaultCellStyle,
      
      cellRendererFramework: params => {
        const row = params?.data;
        const startDate = row?.filtersJson?.startDate;
        const endDate = row?.filtersJson?.endDate;
        return <span className={styles.period}>{moment(startDate).format('D MMM YYYY')} - {moment(endDate).format('D MMM YYYY')}</span>;
      },
    },
    // {
    //   headerName: 'Will Expire',
    //   field: 'expiresAt',
    //   headerClass: styles.rowHeader,
    //   width: 200 * widthConstant,
    //   resizable: true,
    //   wrapText: true,
    //   cellStyle: defaultCellStyle,
    //   valueFormatter: params => formatTimestamp(params.value),
    // },
    {
      headerName: 'Download',
      field: 'downloadUrl',
      headerClass: styles.rowHeader,
      width: 140 * widthConstant,
      resizable: true,
      cellStyle: defaultCellStyle,
      cellRendererFramework: params => {
        const row = params?.data;
        const isDownloadable = canDownload(row);
        if (row?.status === 'IN_PROGRESS') {
          return <span className={styles.inProgress}>In Progress</span>;
        }
        if (row?.status === 'FAILED') {
          return <span className={styles.statusFailed}>Failed</span>;
        }
        return (
          <button
            type="button"
            className={styles.downloadLink}
            disabled={!isDownloadable}
            onClick={() => isDownloadable && onClick('downloadReport', row)}>
            Download
          </button>
        );
      },
    },
  ];

  const rowStyle = {border: 'none'};
  const getRowStyle = params => {
    if (params.node.rowIndex % 2 === 0) {
      return {background: '#f6f6f6', border: 'none'};
    }
  };

  return (
    <div className={styles.deptContainer}>
      <PermitsHeader
        title="Generated Reports"
        onTabClick={id => handleDeptReportTabClick(id, onClick)}
        tabs={DEPT_REPORT_TABS}
        activeTab={2}
      />
      <div className={styles.bodyContainer}>
        <div className={styles.header}>
          <div className={styles.headerText}>
            Download previously generated report files.
          </div>
          <button
            type="button"
            className={styles.refreshBtn}
            onClick={() => onClick('refreshReports')}>
            Refresh
          </button>
        </div>
        <div
          className={[
            'ag-theme-balham vehicleMovementTable',
            styles.tableWrapper,
            totalCount > 10
              ? styles.tableWrapperNormal
              : styles.tableWrapperAutoHeight,
          ].join(' ')}>
          <AgGridReact
            onGridReady={onGridReady}
            rowStyle={rowStyle}
            getRowStyle={getRowStyle}
            rowHoverHighlight={true}
            columnDefs={columnDefs}
            rowHeight={60 * heightConstant}
            headerHeight={60 * heightConstant}
            defaultColDef={{
              sortable: true,
              resizable: true,
              wrapText: true,
              cellStyle: defaultCellStyle,
            }}
            rowClass={styles.gridRowClass}
            pagination={true}
            rowModelType="infinite"
            paginationPageSize={pageSize}
            cacheBlockSize={pageSize}
            domLayout="normal"
            suppressCellSelection={true}
          />
        </div>
      </div>
      <div className={styles.SannaLogo}>
        <SannaLogo />
      </div>
    </div>
  );
};

export default withRouter(Desktop);
